// @flow

import React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { triangle } from 'polished';
import { uniqueId } from 'lodash';

import NavLink from '../../../Link';
// import prop from 'styled-tools/dist/cjs/prop';

type Props = {
  dropDownUrl: string,
  dropDownTitle: any,
  children: any,
};

const Link = styled(NavLink)`
  transition: opacity 0.2s;
  text-decoration: none;
  color: #D4D4D4;
  box-sizing: border-box;

  &:hover {
    color: #fff;
  }

  &[aria-current='true'] {
    opacity: 1;
    cursor: default;
    font-weight: normal;

    ${breakpoint('desktop')`
      font-weight: normal;
    `};
    }
  }
`;

const StyledLink = Link.extend`
  cursor: default;
  pointer-events: none;

  span {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -11px;
      margin-top: -1px;

      ${triangle({
        pointingDirection: 'bottom',
        foregroundColor: 'white',
        width: 6,
        height: 5,
      })};
    }
  }
`;

const Wrapper = styled.li`
  position: relative;
  cursor: default;
  order: 1;

  ${breakpoint('desktop')`
    padding-left: 25px;
    padding-right: 32px;

    &:hover {
      box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.13);
      background-color: #3d3e44;

      & > div > a {
        color: #fff;
      }
    }
  `};

  & > div > a {
    display: flex;
    padding: 10px 0;
    height: 100%;
    align-items: center;
  }

  & > div > ul > li {
    padding: 0 25px;
  }
`;

const ContentWrapper = styled.div`
  padding: 5px 25px 13px 25px;
  height: 100%;

  ${breakpoint('desktop')`
    padding: 0;
  `};
`;

const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${breakpoint('desktop')`
    pointer-events: none;
  `};
`;

const DropDown = styled.ul`
  display: none;
  white-space: nowrap;
  padding-top: 6px;
  left: 0;
  top: 100%;
  z-index: 5;
  text-align: left;
  border-radius: 0 0 4px 4px;
  position: inherit;

  ${breakpoint('desktop')`
    background-color: #3d3e44;
    position: absolute;
    padding: 10px 0 20px 0;

    &:hover,
    ${Wrapper}:hover & {
      display: block;
    }
  `};
`;

const Input = styled.input`
  display: none;

  &:checked ~ ${ContentWrapper} > ${DropDown} {
    display: block;
  }

  &:checked ~ ${ContentWrapper} {
    background-color: #434449;
  }
`;

const Dropdown = (props: Props) => {
  const id = uniqueId('dropdown-');

  return (
    <Wrapper>
      <Input
        id={id}
        type="checkbox"
        checked={props.checkStatus}
        onChange={props.changeCheckStatus}
      />
      <Label htmlFor={id} />
      <ContentWrapper>
        <StyledLink to={props.dropDownUrl}>{props.dropDownTitle}</StyledLink>
        <DropDown>{props.children}</DropDown>
      </ContentWrapper>
    </Wrapper>
  );
};

export default Dropdown;
